module.exports = __webpack_public_path__ + "img/1501788756.922ff33b.jpg";